// Constants
import { PAYMENT_CHANNELS } from './Payment'

// Models
import Model from './Model'

class AccountNumber extends Model {
  get isDeleted () {
    return this.deletedAt != null
  }

  get isVirtual () {
    return this.profileCustomerId !== null
  }

  get isDeletable () {
    return this.isVirtual === true || this.channel !== PAYMENT_CHANNELS.BANK_OF_LITHUANIA
  }

  get isBlocked () {
    return this.status === ACCOUNT_NUMBER_STATUS.BLOCKED
  }

  get isActive () {
    return !this.isBlocked && !this.isDeleted
  }

  static get statusOptions () {
    return [
      { name: 'Active', value: ACCOUNT_NUMBER_STATUS.ACTIVE },
      { name: 'Blocked', value: ACCOUNT_NUMBER_STATUS.BLOCKED }
    ]
  }

  get schema () {
    return [
      'accountNumber',
      'channel',
      'currencies',
      'deletedAt',
      'profileCustomerId',
      'profileCustomerName',
      'status',
      'walletId'
    ]
  }
}

export const ACCOUNT_NUMBER_STATUS = {
  ACTIVE: 'ACTIVE',
  BLOCKED: 'BLOCKED'
}

export default AccountNumber
